import React, { useState } from "react";
import { isEmpty, get } from "lodash";
import {
  faChevronDown,
  faChevronUp,
  faTrashAlt,
  faInfoCircle,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "react-bootstrap";
import { Field } from "formik";
import {
  CsplTable as Table,
  FieldInputPercentageBox,
  InvestmentCard,
  SliderPanel,
} from "../../../../../../components";
import { recordCount, sumOfArray, usCurrency } from "../../../../../../utils";
import AddInvestmentSlider from "./AddInvestmentSlider";

const columns = [
  {
    label: "Investment Name",
    className: "column-investment-name",
    columnName: "investmentName",
  },
  {
    label: "Amount",
    className: "column-amount",
    columnName: "amount",
  },
  {
    label: "Percentage",
    className: "column-percentage",
    columnName: "percentage",
  },
  {
    label: "",
    className: "column-action",
    columnName: "action",
  },
];

const InvestmentDetails = (props) => {
  const {
    data,
    fields,
    values,
    errors,
    hideCard,
    currentHolding,
    handleChange,
    setFieldValue,
    isViewOnly = false,
    isRebalance = false,
    isRebalanceSummary = false,
  } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const [dataIndex, setDataIndex] = useState();

  const showPopup = (idx = null) => {
    setDataIndex(idx);
    setModalOpen(!isModalOpen);
  };

  const onDeleteClick = (idx, index) => {
    setFieldValue(
      fields.transferSourceDetails,
      values.transferSourceDetails.map((item, i) => {
        return i === idx
          ? (item = {
              ...item,
              transferInvestmentDetails: calcAmt(
                item.transferInvestmentDetails.filter(
                  (_, ind) => ind !== index
                ),
                idx,
                false
              ),
            })
          : item;
      })
    );
  };

  const applyChanges = (idx) => {
    let selectedData =
      values.transferSourceDetails[idx].transferInvestmentDetails;
    setFieldValue(
      fields.transferSourceDetails,
      values.transferSourceDetails.map((item, i) => {
        let investments = calcAmt(selectedData, i, true);
        return (item = {
          ...item,
          transferInvestmentDetails: data[i].checked
            ? investments
            : item.transferInvestmentDetails,
        });
      })
    );
  };

  const calcAmt = (val = [], i, isApplyAll) => {
    return val.map(
      (itm) =>
        (itm = {
          ...itm,
          id: isApplyAll ? 0 : itm.id,
          amount: (itm.percentage / 100) * data[i].sourceBalance,
        })
    );
  };

  return (
    <>
      {data &&
        data.map((data, idx) => {
          let fieldArrayName =
            !isViewOnly &&
            `${fields.transferSourceDetails}[${idx}]${fields.transferInvestmentDetails}`;

          let transferEditData = !isRebalance
            ? get(values, `${fieldArrayName}`, [])
            : [];
          let transferViewData = !isRebalanceSummary
            ? get(data, "transferInvestmentDetails", [])
            : isRebalanceSummary
            ? get(data, "rebalanceInvestmentDetails", [])
            : [];

          let currentData =
            isViewOnly &&
            !isRebalance &&
            get(
              currentHolding.filter((_) => _.sourceId === data.sourceId),
              "0.transferInvestmentDetails"
            );

          let total = !isViewOnly
            ? sumOfArray(
                transferEditData.map((_) => (_.amount !== "" ? _.amount : 0))
              )
            : sumOfArray(
                transferViewData.map((_) => (_.amount !== "" ? _.amount : 0))
              );
          let percentage = !isViewOnly
            ? sumOfArray(
                transferEditData.map((_) =>
                  _.percentage !== "" ? _.percentage : 0
                )
              )
            : sumOfArray(
                transferViewData.map((_) =>
                  _.percentage !== "" ? _.percentage : 0
                )
              );

          let error = !isEmpty(errors)
            ? get(errors, `transferSourceDetails[${idx}]`, null)
            : null;
          let invData = isRebalanceSummary
            ? data.rebalanceInvestmentDetails
            : data.transferInvestmentDetails;

          return data.checked || (!isRebalance && isViewOnly) ? (
            <div className="investment-card">
              {data.show ? (
                <>
                  <div
                    className="d-flex justify-content-start mb-2 plr-15"
                    onClick={() => hideCard(idx)}
                  >
                    <FontAwesomeIcon
                      className="ft-16 fw-400 mt-1 mr-3"
                      icon={faChevronUp}
                    />
                    <div className="ft-16 fw-500">
                      {data.sourceName} - Investments
                    </div>
                  </div>

                  <Row className="plr-15">
                    <Col className="current-hisRebalanceoldings" md={3} lg={4}>
                      <div className="mt-3 mb-3">
                        <div className="ft-14 fw-500">Current holdings</div>
                        <span className="ft-12 fw-400 grey-text">
                          {isViewOnly && !isRebalance
                            ? !isEmpty(currentHolding) &&
                              recordCount(currentData.length)
                            : recordCount(
                                data.transferInvestmentDetails.length
                              )}{" "}
                          investments
                        </span>
                        <InvestmentCard
                          data={
                            isViewOnly && !isRebalance
                              ? !isEmpty(currentHolding) && currentData
                              : data.transferInvestmentDetails
                          }
                        />
                      </div>
                    </Col>
                    <Col md={9} lg={8}>
                      <div className="d-flex justify-content-between mt-3 mb-3 ml-4">
                        <div>
                          <div className="ft-14 fw-500">Future holdings</div>
                          <span className="ft-12 fw-400 grey-text">
                            {isViewOnly
                              ? recordCount(invData.length)
                              : recordCount(
                                  get(values, fieldArrayName, []).length
                                )}{" "}
                            investments
                          </span>
                        </div>
                        {!isViewOnly && (
                          <Button
                            style={{ fontSize: "12px" }}
                            variant="secondary"
                            onClick={() => {
                              showPopup(idx);
                            }}
                          >
                            Add Investment
                          </Button>
                        )}
                      </div>
                      <div>
                        <Table className="ml-4">
                          <Table.Thead>
                            <Table.Tr>
                              {columns.map((item, index) => {
                                return (
                                  <Table.Th
                                    key={index}
                                    className={item.className}
                                  >
                                    {item.label}
                                  </Table.Th>
                                );
                              })}
                            </Table.Tr>
                          </Table.Thead>
                          {isViewOnly ? (
                            <Table.Tbody>
                              {invData.map((investment, index) => {
                                return (
                                  <Table.Tr key={index}>
                                    {columns.map((item, cellIndex) => {
                                      const getContent = () => {
                                        if (item.columnName === "amount") {
                                          return usCurrency(
                                            investment[item.columnName]
                                          );
                                        }
                                        if (item.columnName === "percentage") {
                                          return (
                                            <div
                                              style={{
                                                marginLeft: "2rem",
                                              }}
                                            >
                                              {Number(
                                                investment[
                                                  item.columnName
                                                ].toFixed(2)
                                              )}{" "}
                                              %
                                            </div>
                                          );
                                        }
                                        if (
                                          investment.restricted &&
                                          item.columnName === "investmentName"
                                        ) {
                                          return (
                                            <div className="d-flex flex-column">
                                              <div>
                                                <FontAwesomeIcon
                                                  icon={faInfoCircle}
                                                  style={{ fontSize: "10px" }}
                                                  color="#828282"
                                                  className="mr-1"
                                                />
                                                <span className="ft-10 grey-text">
                                                  Restricted - Transfer In
                                                </span>
                                              </div>
                                              <div>
                                                {investment["investmentName"]}
                                              </div>
                                            </div>
                                          );
                                        }
                                        return investment[item.columnName];
                                      };

                                      return (
                                        <Table.Td
                                          key={cellIndex}
                                          className={item.className}
                                        >
                                          {getContent()}
                                        </Table.Td>
                                      );
                                    })}
                                  </Table.Tr>
                                );
                              })}
                            </Table.Tbody>
                          ) : (
                            <Table.Tbody>
                              {!isEmpty(values) &&
                                get(values, fieldArrayName, []).map(
                                  (investment, index) => {
                                    return (
                                      <Table.Tr key={index}>
                                        {columns.map((item, cellIndex) => {
                                          const getContent = () => {
                                            const sourceAmt =
                                              data.sourceBalance;
                                            const invAmt = get(
                                              values,
                                              `${fieldArrayName}[${index}]${fields.percentage}`
                                            );

                                            const fieldName = `${fieldArrayName}[${index}]${item.columnName}`;
                                            if (
                                              item.columnName === "percentage"
                                            ) {
                                              return (
                                                <Field
                                                  name={fieldName}
                                                  autoComplete="off"
                                                  size={"xxs"}
                                                  value={get(values, fieldName)}
                                                  onChange={(e) => {
                                                    setFieldValue(
                                                      `${fieldArrayName}[${index}]${fields.amount}`,
                                                      (e.target.value / 100) *
                                                        sourceAmt
                                                    );
                                                    handleChange(e);
                                                  }}
                                                  component={
                                                    FieldInputPercentageBox
                                                  }
                                                />
                                              );
                                            }
                                            if (item.columnName === "action") {
                                              return (
                                                <FontAwesomeIcon
                                                  icon={faTrashAlt}
                                                  size="lg"
                                                  color="#EB4E3D"
                                                  className="pointer"
                                                  onClick={() =>
                                                    onDeleteClick(idx, index)
                                                  }
                                                />
                                              );
                                            }
                                            if (item.columnName === "amount") {
                                              return usCurrency(
                                                (invAmt / 100) * sourceAmt
                                              );
                                            }
                                            if (
                                              investment.restricted &&
                                              item.columnName ===
                                                "investmentName"
                                            ) {
                                              return (
                                                <div className="d-flex flex-column">
                                                  <div>
                                                    <FontAwesomeIcon
                                                      icon={faInfoCircle}
                                                      style={{
                                                        fontSize: "10px",
                                                      }}
                                                      color="#828282"
                                                      className="mr-1"
                                                    />
                                                    <span className="ft-10 grey-text">
                                                      Restricted - Transfer In
                                                    </span>
                                                  </div>
                                                  <div>
                                                    {
                                                      investment[
                                                        item.columnName
                                                      ]
                                                    }
                                                  </div>
                                                </div>
                                              );
                                            }
                                            return investment[item.columnName];
                                          };

                                          return (
                                            <Table.Td
                                              key={cellIndex}
                                              className={item.className}
                                            >
                                              {getContent()}
                                            </Table.Td>
                                          );
                                        })}
                                      </Table.Tr>
                                    );
                                  }
                                )}
                            </Table.Tbody>
                          )}
                        </Table>
                      </div>
                      <div className="d-flex ft-16 fw-500 mt-2">
                        <p className="total">Total</p>
                        <p className="amount">{usCurrency(total)}</p>
                        <p
                          className="percentage"
                          style={error != null ? { color: "#f16973" } : {}}
                        >
                          {percentage?.toFixed(2)} %
                        </p>
                      </div>
                      <div className="d-flex justify-content-end ft-16 fw-500 mr-3">
                        {error != null && (
                          <span className="d-flex justify-content-end ft-14 error-text mb-1">
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              color="#f16973"
                              className="mt-1 mr-1"
                            />
                            {error}
                          </span>
                        )}
                      </div>
                    </Col>
                  </Row>
                  {!isViewOnly && (
                    <>
                      <div className="border-line-seperator" />
                      <div className="d-flex justify-content-between align-items-baseline current-holdings plr-15">
                        <div className="ft-12 fw-500 mt-3 mb-3">
                          Use same future holdings for all selected sources
                        </div>
                        <Button
                          style={{ fontSize: "12px" }}
                          variant="secondary"
                          onClick={() => applyChanges(idx)}
                        >
                          Apply
                        </Button>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div
                  className="d-flex justify-content-start mb-3 plr-15"
                  onClick={() => hideCard(idx)}
                >
                  <FontAwesomeIcon
                    className="ft-16 fw-400 mt-1 mr-3"
                    icon={faChevronDown}
                  />
                  <div className="ft-16 fw-500">
                    {data.sourceName} - Investments
                  </div>
                </div>
              )}
            </div>
          ) : null;
        })}

      <SliderPanel
        isOpen={isModalOpen}
        size="40"
        showCancel={false}
        backdropClicked={() => setModalOpen(!isModalOpen)}
      >
        <AddInvestmentSlider
          {...props}
          index={dataIndex}
          showPopup={showPopup}
          fields={fields}
        />
      </SliderPanel>
    </>
  );
};

export default InvestmentDetails;
